import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import NoItemResult from '../../../../components/results/NoItemResult';
import { type PermissionValues } from '../../../../utilities/hasPermissions';

export type BankModuleEmptyListProps = {
    permissions: Pick<PermissionValues, 'hasCreatePermission'>;
};

const BankModuleEmptyList = ({ permissions }: BankModuleEmptyListProps) => {
    const { t } = useTranslation(['bankModuleDetails']);
    const navigate = useNavigate();
    const { hasCreatePermission } = permissions;

    return (
        <NoItemResult
            extra={
                hasCreatePermission && (
                    <Button onClick={() => navigate('/admin/banks/add')} type="primary">
                        {t('bankModuleDetails:emptyList.noData.action')}
                    </Button>
                )
            }
            subTitle={t('bankModuleDetails:emptyList.noData.message')}
        />
    );
};

export default BankModuleEmptyList;
